<svg [attr.width]="width" [attr.height]="height" [attr.viewBox]="viewBox" fill="none"  align="center" xmlns="http://www.w3.org/2000/svg">
      <path [attr.d]="path"/>
</svg>